module.exports = __webpack_public_path__ + "img/vippack_cod_dg_k.9c76a22e.png";